function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';

// Lazy-load Lottie animations with a delay.
var Lottie = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var delay = props.delay;
  var LottieAnimation = /*#__PURE__*/lazy(function () {
    return new Promise(function (resolve) {
      setTimeout(function () {
        return resolve(import('./LottieAnimation'));
      }, delay);
    });
  });
  return /*#__PURE__*/React.createElement(Suspense, null, /*#__PURE__*/React.createElement(LottieAnimation, _extends({
    ref: ref
  }, props)));
});
Lottie.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  renderer: PropTypes.string,
  rendererSettings: PropTypes.shape({
    preserveAspectRatio: PropTypes.string
  }),
  data: PropTypes.object,
  path: PropTypes.string,
  segments: PropTypes.array,
  // Events
  onInit: PropTypes.func,
  onDestroy: PropTypes.func,
  // Options
  delay: PropTypes.number,
  autoPlay: PropTypes.bool,
  loop: PropTypes.bool,
  speed: PropTypes.number,
  direction: PropTypes.number,
  activateOnHover: PropTypes.bool,
  pauseOnClick: PropTypes.bool,
  olaTime: PropTypes.number,
  startPosition: PropTypes.number,
  ariaLabel: PropTypes.string
};
Lottie.defaultProps = {
  id: null,
  className: null,
  renderer: 'svg',
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid meet'
  },
  data: null,
  path: null,
  segments: null,
  // Events
  onInit: function onInit() {},
  onDestroy: function onDestroy() {},
  // Options
  delay: null,
  autoPlay: true,
  loop: true,
  speed: 1,
  direction: 1,
  activateOnHover: false,
  pauseOnClick: false,
  ariaLabel: 'animation',
  olaTime: 300,
  startPosition: null
};
export default Lottie;